import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { RootState, StoreDispatch } from 'src/store';

export const useStoreDispatch: () => StoreDispatch = useDispatch;
export const useStoreSelector: TypedUseSelectorHook<RootState> = useSelector;
